const Genders = [
  { id: 1, value: "male", label: "Male", category: "binary" },
  { id: 2, value: "female", label: "Female", category: "binary" },
  { id: 20, value: "other", label: "Other", category: "other" },
];

export default Genders;
